// FileUploader.js
import React, { useRef } from "react";
import { ReactComponent as EyeIcon } from "../../../assets/svgs/eye.svg";
import { ReactComponent as UploadButtonIcon } from "../../../assets/svgs/uploadButtonIcon.svg";

const FileUploader = ({ files, setFiles }) => {
  const fileInputRef = useRef();

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files).filter((file) => {
      return (
        [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ].includes(file.type) && file.size < 2 * 1024 * 1024
      );
    });

    setFiles((prev) => [...prev, ...newFiles]);
  };

  const handleDelete = (index) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
  };

  const openFile = (file) => {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };

  return (
    <div className="p-4">
      {/* Upload Area */}
      <div
        className="bg-gray-100 border border-gray-300  rounded-md flex justify-between items-center cursor-pointer"
        onClick={() => fileInputRef.current.click()}
      >
        <div className="text-gray-500 p-3">Please select your file here</div>
        <button className="bg-[#06513D] text-white px-10 rounded-r py-3 h-full">
          <UploadButtonIcon />
        </button>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept=".pdf,.doc,.docx"
          className="hidden"
          onChange={handleFileChange}
        />
      </div>
      <p className="text-sm text-gray-400 mt-1">
        Your file should be in .pdf, .doc, .docx with less than 2MB size.
      </p>

      {/* Uploaded Files */}
      {files.map((file, index) => (
        <div key={index} className="mt-3  flex justify-between items-center">
          <span className="text-sm text-gray-700 truncate bg-gray-100 px-4 py-2 rounded w-full mr-8">
            {file.name}
          </span>
          <div className="flex items-center gap-3">
            <button
              onClick={() => openFile(file)}
              className="bg-[#06513D] text-white  rounded-full w-8  h-8  mx-auto  cursor-pointer"
            >
              <EyeIcon className="mx-auto" />
            </button>
            <button
              onClick={() => handleDelete(index)}
              className="bg-[#06513D] text-white  rounded-full  w-8 h-8   cursor-pointer"
            >
              X
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FileUploader;
